import React from "react";
import logo from "../../assets/images/mamamyanmar/logo.png";


function Header() {
    return (
        <div className="navbar bg-base-100">
            <div className="navbar-start"></div>
            <div className="navbar-center">
                <img src={logo} width={200} height={180}></img>
            </div>
            <div className="navbar-end">
            </div>
        </div>
    );
}

export default Header; 